import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useScreenWidth from "../../../../hooks/useScreenWidth";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Loader, ButtonModifier } from "../../../../components";
import { ShowTableJualChild } from "../../../../components/ShowTable";
import { postRequest } from "../../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, Pagination, ButtonGroup } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import PrintIcon from "@mui/icons-material/Print";

const TampilJual = () => {
  const screenSize = useScreenWidth();
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [noNotaJual, setNoNotaJual] = useState("");
  const [jenisJual, setJenisJual] = useState("");
  const [tanggalJual, setTanggalJual] = useState("");
  const [tanggalJualDate, setTanggalJualDate] = useState();
  const [totalJual, setTotalJual] = useState("");
  const [pelanggan, setPelanggan] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [totalSubtotalJualChild, setTotalSubtotalJualChild] = useState(0);

  const [jualsChildPagination, setJualsChildPagination] = useState([]);
  const [previewNota, setPreviewNota] = useState(false);
  const navigate = useNavigate();
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN";
  let isEditableAdmin =
    user.tipeUser === "ADMIN" &&
    tanggalJualDate?.getFullYear() === today.getFullYear() &&
    tanggalJualDate?.getMonth() === today.getMonth() &&
    tanggalJualDate?.getDate() === today.getDate();
  let isEditable = isEditableManager || isEditableAdmin;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");
  const PER_PAGE = 20;

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const ITEMS_PER_NOTA_PAGE = 9;

  const chunkArray = (array, size) => {
    const result = [];

    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }

    return result;
  };

  const notaPages = chunkArray(jualsChildPagination, ITEMS_PER_NOTA_PAGE);

  useEffect(() => {
    getJualById();
  }, []);

  const getJualById = async () => {
    setLoading(true);
    const response = await postRequest(`/juals/${id}`, {}, navigate, dispatch);
    setNoNotaJual(response.data.noNotaJual);
    setJenisJual(response.data.jenisJual);
    setTanggalJual(response.data.tanggalJualFormatted);
    setTanggalJualDate(new Date(response.data.tanggalJual));
    setTotalJual(response.data.totalJual);
    setPelanggan(response.data.pelanggan);
    if (response.data.coa) {
      setKodeCOA(`${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`);
    }

    const response2 = await postRequest(
      `/jualChildsByJualPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
      { jualId: response.data.id },
      navigate,
      dispatch,
    );
    setJualsChildPagination(response2.data.juals);
    let tempTotalSubtotalJualChild = 0;
    for (let data of response2.data.juals) {
      tempTotalSubtotalJualChild += data.subtotalJualChild;
    }
    setTotalSubtotalJualChild(tempTotalSubtotalJualChild);
    setLoading(false);
  };

  const deleteJual = async (id) => {
    setLoading(true);
    try {
      await postRequest(`/deleteJual/${id}`, {}, navigate, dispatch);
      navigate("/daftarJual");
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  // const handleGeneratePdf = () => {
  //   const doc = new jsPDF({
  //     format: "a4",
  //     // format: "a6",
  //     unit: "px",
  //   });
  //   // const doc = new jsPDF({
  //   //   unit: "px",
  //   //   format: [420, 297], // setengah folio (A5) = 148 × 210 mm = sekitar 420x297 px di jsPDF
  //   // });
  //   doc.html(reportTemplateRef.current, {
  //     async callback(doc) {
  //       await window.open(URL.createObjectURL(doc.output("blob")));
  //     },
  //     html2canvas: { scale: 0.48 },
  //     // html2canvas: { scale: 0.44 },
  //     // html2canvas: { scale: 0.24 },
  //   });
  // };

  const handleGeneratePdf = async () => {
    try {
      const notaElements =
        reportTemplateRef.current.querySelectorAll(".nota-page");

      const doc = new jsPDF({
        format: "a4",
        unit: "px",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      for (let i = 0; i < notaElements.length; i++) {
        const element = notaElements[i];

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
        });

        const rotatedCanvas = document.createElement("canvas");
        const rotatedCtx = rotatedCanvas.getContext("2d");

        rotatedCanvas.width = canvas.height;
        rotatedCanvas.height = canvas.width;

        rotatedCtx.translate(rotatedCanvas.width, 0);
        rotatedCtx.rotate(Math.PI / 2);
        rotatedCtx.drawImage(canvas, 0, 0);

        const imgData = rotatedCanvas.toDataURL("image/png");

        const imgWidth = rotatedCanvas.width;
        const imgHeight = rotatedCanvas.height;

        const ratio = pageHeight / imgHeight;

        const finalWidth = imgWidth * ratio;
        const finalHeight = imgHeight * ratio;

        const x = pageWidth - finalWidth;
        const y = 0;

        if (i > 0) {
          doc.addPage();
        }

        doc.addImage(
          imgData,
          "PNG",
          x,
          y,
          finalWidth,
          finalHeight,
          undefined,
          "FAST",
        );
      }

      window.open(URL.createObjectURL(doc.output("blob")));
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Penjualan</h3>
      <h5 style={{ fontWeight: 400 }}>Jual</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarJual")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          {id && (
            <Button
              color="primary"
              startIcon={<PrintIcon />}
              onClick={() => {
                setPreviewNota(!previewNota);
              }}
            >
              Nota
            </Button>
          )}
        </ButtonGroup>
      </Box>
      {/* {previewNota && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGeneratePdf}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} id="content" style={pdfContainer}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <div></div>
              <div>
                <div style={{ display: "flex" }}>
                  <div style={{ visibility: "hidden", ...notaHeaderTitle }}>
                    a
                  </div>
                  <div style={notaHeaderData}></div>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={notaHeaderTitle}>
                    <b>
                      <u>Tuan</u>
                    </b>
                  </div>
                  <div style={notaHeaderData}>{pelanggan.namaPelanggan}</div>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ ...notaHeaderTitle, marginTop: "-10px" }}>
                    <b>Toko</b>
                  </div>
                  <div style={notaHeaderData}>{tanggalJual}</div>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <div>
                <b>NOTA No.</b>
              </div>
              <div
                style={{
                  borderBottom: "1px solid black",
                  width: "200px",
                  paddingLeft: "4px",
                }}
              >
                {noNotaJual}
              </div>
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
              <table
                style={{
                  flex: 1,
                  borderCollapse: "collapse", // ensures borders merge cleanly
                  width: "100%",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ ...notaTableHead, width: "11%" }}>QTY</th>
                    <th style={{ ...notaTableHead, width: "61%" }}>
                      NAMA BARANG
                    </th>
                    <th style={{ ...notaTableHead, width: "12%" }}>HARGA</th>
                    <th style={{ ...notaTableHead, width: "16%" }}>JUMLAH</th>
                  </tr>
                </thead>
                <tbody>
                  {jualsChildPagination.map((row) => {
                    return (
                      <tr key={row.id}>
                        <td style={{ ...notaTableBody }}>
                          {row.jumlah1.toLocaleString("en-US")} {row.satuan1}
                        </td>
                        <td style={{ ...notaTableBody }}>{row.namaBarang}</td>
                        <td style={{ ...notaTableBody, textAlign: "end" }}>
                          {row.harga.toLocaleString("en-US")}
                        </td>
                        <td style={{ ...notaTableBody, textAlign: "end" }}>
                          {row.subtotalJualChild.toLocaleString("en-US")}
                        </td>
                      </tr>
                    );
                  })}

                  <tr key="total">
                    <td style={{ ...notaTableBody }}></td>
                    <td style={{ ...notaTableBody }}></td>
                    <td style={{ ...notaTableBody, textAlign: "end" }}></td>
                    <td style={{ ...notaTableBody, textAlign: "end" }}>
                      Rp. {totalSubtotalJualChild.toLocaleString("en-US")}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )} */}
      {previewNota && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGeneratePdf}
          >
            CETAK
          </Button>

          <div ref={reportTemplateRef}>
            {notaPages.map((items, pageIndex) => {
              const isLastPage = pageIndex === notaPages.length - 1;

              return (
                <div
                  key={pageIndex}
                  className="nota-page"
                  style={{
                    ...pdfContainer,
                    marginBottom: "40px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <div></div>
                    <div>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{ visibility: "hidden", ...notaHeaderTitle }}
                        >
                          a
                        </div>
                        <div style={notaHeaderData}></div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={notaHeaderTitle}>
                          <b>
                            <u>Tuan</u>
                          </b>
                        </div>
                        <div style={notaHeaderData}>
                          {pelanggan.namaPelanggan}
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ ...notaHeaderTitle, marginTop: "-10px" }}>
                          <b>Toko</b>
                        </div>
                        <div style={notaHeaderData}>{tanggalJual}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "10px",
                    }}
                  >
                    <div>
                      <b>NOTA No.</b>
                    </div>
                    <div
                      style={{
                        borderBottom: "1px solid black",
                        width: "200px",
                        paddingLeft: "4px",
                      }}
                    >
                      {noNotaJual}
                    </div>
                  </div>

                  <div style={{ display: "flex", marginTop: "10px" }}>
                    <table
                      style={{
                        flex: 1,
                        borderCollapse: "collapse",
                        width: "100%",
                      }}
                    >
                      <thead>
                        <tr>
                          <th style={{ ...notaTableHead, width: "11%" }}>
                            QTY
                          </th>
                          <th style={{ ...notaTableHead, width: "61%" }}>
                            NAMA BARANG
                          </th>
                          <th style={{ ...notaTableHead, width: "12%" }}>
                            HARGA
                          </th>
                          <th style={{ ...notaTableHead, width: "16%" }}>
                            JUMLAH
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {items.map((row) => (
                          <tr key={row.id}>
                            <td style={notaTableBody}>
                              {row.jumlah1.toLocaleString("en-US")}{" "}
                              {row.satuan1}
                            </td>
                            <td style={notaTableBody}>{row.namaBarang}</td>
                            <td style={{ ...notaTableBody, textAlign: "end" }}>
                              {row.harga.toLocaleString("en-US")}
                            </td>
                            <td style={{ ...notaTableBody, textAlign: "end" }}>
                              {row.subtotalJualChild.toLocaleString("en-US")}
                            </td>
                          </tr>
                        ))}

                        {isLastPage && (
                          <tr key="total">
                            <td style={notaTableBody}></td>
                            <td style={notaTableBody}></td>
                            <td
                              style={{ ...notaTableBody, textAlign: "end" }}
                            ></td>
                            <td style={{ ...notaTableBody, textAlign: "end" }}>
                              Rp.{" "}
                              {totalSubtotalJualChild.toLocaleString("en-US")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={`/daftarJual/jual/${id}/tambahJualChild`}
              editLink={`/daftarJual/jual/${id}/edit`}
              deleteUser={deleteJual}
              nameUser={noNotaJual}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>Jual</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Jual :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noNotaJual}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Jual :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={jenisJual}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Jual :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tanggalJual}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Pelanggan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={`${pelanggan.kodePelanggan} - ${pelanggan.namaPelanggan}`}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Kas :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={kodeCOA} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={totalJual.toLocaleString("en-US")}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableJualChild id={id} currentPosts={jualsChildPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilJual;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const subTitleText = {
  fontWeight: "900",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const pdfContainer = {
  // padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "18px",
  fontFamily: "sans-serif",
  // width: "1000px",
  width: "900px",
  padding: "25px",
};

const notaHeaderTitle = {
  width: "50px",
  textAlign: "end",
  marginRight: "6px",
};

const notaHeaderData = {
  borderBottom: "1px dotted black",
  width: "300px",
  paddingLeft: "4px",
};

const notaTableHead = {
  border: "1px solid black",
  padding: "8px",
  textAlign: "center",
};

const notaTableBody = {
  border: "1px solid black",
  padding: "8px",
};
